import {Dialog} from '@headlessui/react';
import {FC} from 'react';
import {RegistrationButton} from '../RegistrationButton/RegistrationButton';
import styles from './SnilsErrorModal.module.css';

type Props = {
	isOpen: boolean;
	message: string;
	onClose: () => void;
};

const CloseIcon = () => (
	<svg className={styles.closeIcon} viewBox="0 0 24 24" fill="none" aria-hidden>
		<path d="M4 4L20 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		<path d="M4 20L20 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

/** Ошибка PATCH /identification/snils: «Повторить» только закрывает модалку. */
export const SnilsErrorModal: FC<Props> = ({isOpen, message, onClose}) => (
	<Dialog open={isOpen} onClose={onClose} className={styles.root}>
		<div className={styles.overlay} aria-hidden="true" />

		<div className={styles.container}>
			<Dialog.Panel className={styles.panel} data-testid="snils-error-modal">
				<button type="button" className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
					<CloseIcon />
				</button>

				<div className={styles.body}>
					<Dialog.Title className={styles.title}>Упс! Что-то не так</Dialog.Title>
					<p className={styles.description}>{message}</p>
				</div>

				<div className={styles.footer}>
					<RegistrationButton variant="primary" onClick={onClose}>
						Повторить
					</RegistrationButton>
				</div>
			</Dialog.Panel>
		</div>
	</Dialog>
);
